<template>
  <div v-loading="loading">
    <FormBox :title="$t('school.payment_info')">
      <el-form
        ref="formdata"
        :model="formdata"
        label-position="top"
        class="form_type1_box"
        hide-required-asterisk
        :rules="ruleForm"
      >
        <el-row :gutter="86">
          <el-col :xs="24" :sm="24">
            <el-form-item :label="$t('school.payment_name')">
              <el-input
                v-if="$i18n.locale === 'PT'"
                type="textarea"
                autosize
                v-model="data.cheque.namePt"
                disabled
              ></el-input>
              <el-input
                v-else
                type="textarea"
                autosize
                v-model="data.cheque.nameCn"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.hzmbMoRenew.amount')">
              <el-input v-model="data.cheque.amount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.hzmbMoRenew.taxAmount')">
              <el-input v-model="data.cheque.taxAmount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.hzmbMoRenew.totalAmount')">
              <el-input v-model="data.cheque.totalAmount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24">
            <el-form-item
              :label="$t('message.DataRegistration.Taxi.payment')"
              prop="paymentChannel"
            >
              <div>
                <el-radio
                  v-for="item in paymentMethod"
                  :key="item.paymentChannel"
                  v-model="formdata.paymentChannel"
                  :value="item.paymentChannel"
                  :label="item.paymentChannel"
                  @change="changePaymentChannel"
                >
                  <img
                    class="mpay_icon"
                    :src="require(`@/assets/${item.icon}.png`)"
                    alt=""
                  />
                </el-radio>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24">
            <div class="payment_notice">
              <div class="pn_title">
                {{ $t("school.notice") }}
                <span
                  style="color: #ee7a34; font-size: 20px; font-weight: bold"
                >
                  {{ $t("school.payment_notice") }}
                </span>
              </div>
              <ul class="pn_list">
                <li>
                  <span class="pn_email_text">{{
                    formdata.paymentChannel === "CEP"
                      ? $t("school.email_required")
                      : $t("school.email")
                  }}</span>
                  <!-- 電子郵件 -->
                  <el-form-item ref="email" label="" prop="email">
                    <el-input
                      v-model="formdata.email"
                      :placeholder="$t('school.email_plh')"
                    ></el-input>
                  </el-form-item>
                  <!-- 電子郵件確認 -->
                  <el-form-item ref="confirmEmail" label="" prop="confirmEmail">
                    <el-input
                      v-model="formdata.confirmEmail"
                      :placeholder="$t('school.email_again_plh')"
                    ></el-input>
                  </el-form-item>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="payment-check--row">
        <el-checkbox v-model="checked" class="sendSms_checkbox"> </el-checkbox>
        <span class="check-btn el-checkbox__label" @click="showTerms = true">
          {{ $t("message.hzmbMoRenew.terms") }}
        </span>
      </div>
    </FormBox>
    <div class="next_btn">
      <GradientBtn :loading="submitLoading" @click="frequency">
        {{ $t("school.payment_btn") }}
        {{ data.cheque.totalAmount }}
      </GradientBtn>
    </div>
    <!-- 重複支付彈窗 -->
    <ComputetTimeDialog
      :show="showRepeatDialog"
      :timeParams="timeParams"
      @close="handleClose"
    ></ComputetTimeDialog>
    <!-- 使用條款彈窗 -->
    <el-dialog
      :visible.sync="showTerms"
      :title="$t('message.hzmbMoRenew.terms_title')"
      width="665px"
      class="dialog_center_type trems_dialog"
      @close="showTerms = false"
    >
      <div v-html="$t('message.hzmbMoRenew.hzmbMoTerms')" class="m-terms-body"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showTerms = false">{{
          $t("message.back")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import { applicantTypeFilter, formatAmount } from "@/filters";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
import HzmbMoRenewApplicationAPI from "@/api/HzmbMoRenewApplicationAPI";
import FormBox from "../components/FormBox.vue";
import GradientBtn from "@/components/GradientBtn.vue";
import HzmbMoRenewApplicationPublicAPI from "@/api/HzmbMoRenewApplicationPublicAPI";
import ComputetTimeDialog from "@/components/ComputetTimeDialog.vue";
export default {
  components: { FormBox, GradientBtn, ComputetTimeDialog },
  data() {
    let emailCheck = (rule, value, callback) => {
      if (this.formdata && this.formdata.paymentChannel === "CEP" && !value) {
        callback(new Error(i18n.t("message.formRuleMessage.notNull")));
      }
      if (this.formdata.confirmEmail && value !== this.formdata.confirmEmail) {
        callback(
          new Error(i18n.t("message.formRuleMessage.taxi_email_confirm"))
        );
      } else {
        callback();
      }
    };
    let confirmEmailCheck = (rule, value, callback) => {
      if (this.formdata && this.formdata.paymentChannel === "CEP" && !value) {
        callback(new Error(i18n.t("message.formRuleMessage.notNull")));
      }
      if (this.formdata.email && !value) {
        callback(new Error(i18n.t("message.formRuleMessage.taxi_email")));
      } else if (this.formdata.email && value !== this.formdata.email) {
        callback(
          new Error(i18n.t("message.formRuleMessage.taxi_email_confirm"))
        );
      } else {
        callback();
      }
    };
    return {
      businessType: this.$route.params.businessType,
      serviceType: this.$route.params.serviceType,
      loading: false,
      submitLoading: false,
      data: { cheque: {} },
      formdata: {},
      paymentMethod: [],
      checked: null,
      showRepeatDialog: false,
      timeParams: {},
      showTerms: false,

      ruleForm: {
        paymentChannel: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        email: [
          { validator: emailCheck, trigger: "blur" },
          {
            type: "email",
            message: i18n.t("message.formRuleMessage.email"),
            trigger: ["blur"],
          },
        ],
        confirmEmail: [
          { validator: confirmEmailCheck, trigger: "blur" },
          {
            type: "email",
            message: i18n.t("message.formRuleMessage.email"),
            trigger: ["blur"],
          },
        ],
      },
    };
  },
  computed: {
    applicantType() {
      return applicantTypeFilter(this.serviceType);
    },
  },
  methods: {
    // 獲取支付方式
    async getPaymentMethod() {
      const serviceType = this.serviceType;
      this.loading = true;
      try {
        let paymentMethod = await ServiceTypeConfigAPI.getPayMethod(
          serviceType
        );
        this.paymentMethod = paymentMethod.map((ele) => {
          ele.name = ele.paymentChannel;
          ele.icon = ["mpay", "gov_pay", "cep"][
            ["MPAY", "GOV_PAY", "CEP"].indexOf(ele.paymentChannel)
          ];
          return ele;
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    // 准入獲取資料
    async get() {
      this.loading = true;
      try {
        const applicationId = this.$route.params.applicationId;
        let data = await HzmbMoRenewApplicationAPI.getById(applicationId);
        data.cheque.amount = formatAmount(data.cheque.amount);
        data.cheque.taxAmount = formatAmount(data.cheque.taxAmount);
        data.cheque.totalAmount = formatAmount(data.cheque.totalAmount);
        this.data = data;
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    // 關閉重複支付提示彈窗
    handleClose() {
      this.showRepeatDialog = false;
      this.timeParams = {};
    },
    // 檢查支付頻率
    async frequency() {
      this.$refs["formdata"].validate(async (valid) => {
        if (valid) {
          if (!this.checked) {
            this.$alert(this.$t("message.hzmbMoRenew.terms_agree"));
            return;
          }
          this.submitLoading = true;
          try {
            await HzmbMoRenewApplicationPublicAPI.frequency(this.data.id);
            this.startPay();
          } catch (error) {
            const { code, message } = error;
            if (code === "REPEAT_PAYMENT_ERROR") {
              this.timeParams = {
                currentTime: this.$formatDate(
                  new Date().toISOString(),
                  "yyyy-MM-dd HH:mm:ss"
                ),
                formatCreateTime: message,
              };
              this.showRepeatDialog = true;
            } else if (code === "PAYMENT_CHECK_FAIL") {
              const errMsg = JSON.parse(message);
              this.$message.error(
                errMsg[`failedMsg${this.$t("message.lans")}`]
              );
            } else {
              this.$error(error);
            }
            this.submitLoading = false;
          }
        }
      });
    },
    async startPay() {
      this.submitLoading = true;
      try {
        const serviceType = this.serviceType;
        const { id } = this.data;
        const { paymentChannel, email } = this.formdata;
        const resourcePath = process.env.VUE_APP_BASE_RESOURCE_PATH;
        const url = `${resourcePath}/public/api/v1/application/hzmb-mo-renew/payment/start/pay/${serviceType}`;
        const params = `?applicationId=${id}&channel=${paymentChannel}${
          email ? `&email=${email}` : ""
        }`;
        window.location.href = url + params;
      } catch (error) {
        this.$error(error);
      }
    },
    changePaymentChannel(val) {
      this.$refs["formdata"].validateField("email");
      this.$refs["formdata"].validateField("confirmEmail");
    },
  },
  async created() {
    this.get();
    this.getPaymentMethod();
  },
};
</script>

<style lang="scss" scoped>
/deep/.m-divider {
  margin: 16px;
}
.payment-check--row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.check-btn {
  cursor: pointer;
  font-size: 18px;
  line-height: 34px;
  white-space: pre-wrap;
  color: #5ba7ad;
}
/deep/.sendSms_checkbox {
  .el-checkbox__inner {
    width: 18px;
    height: 18px;
  }
  .el-checkbox__inner::after {
    height: 10px;
    left: 6px;
  }
}

.el-checkbox__label {
  font-size: 18px;
  line-height: 34px;
  white-space: pre-wrap;
  display: inline;
}
.payment_notice {
  max-width: 700px;
  margin: auto;
  padding: 30px;
  background: #fef9f3;
  border: 1px solid #facd91;
  border-radius: 5px;
}
.pn_title {
  color: #f59a23;
  font-size: 26px;
  margin-bottom: 20px;
}
.pn_list {
  /deep/.el-form {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  /deep/.el-form-item {
    margin-right: 20px;
  }
  /deep/.el-form-item.is-error .el-input__inner {
    box-shadow: 0 0 black;
  }
}
.pn_list li {
  margin-bottom: 12px;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pn_list li span {
  display: inline-block;
  min-width: 180px;
}
.pn_list li .el-input {
  flex: 1;
  margin-right: 20px;
}
/deep/.pn_list li .el-input input {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #333;
  background-color: transparent;
  text-align: center;
}
/deep/.el-radio {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/.el-radio + .el-radio {
  margin-top: 20px;
}
/deep/.el-radio__label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.mpay_icon {
  width: auto;
  height: 50px;
  display: block;
  margin-right: 10px;
}
/deep/.m-terms-body {
  ul {
    list-style-type: decimal;
    padding-left: 20px;
  }
}
</style>
